import EventEmitter from 'events'
import * as firebase from "firebase";
import firebaseApp from  "./FirebaseApp";

class userFunctions extends EventEmitter {
	constructor () {
		super()
		this.ref = firebase.database().ref('users')
	}

	create ({username, uid}, onComplete) {
    firebase.database().ref('users/' + uid).set({
      username: username,
    }, onComplete);
	}


	attachFirebaseListeners () {
	    this.ref.on('child_added', this.onAdded, this)
	    this.ref.on('child_removed', this.onRemoved, this)
	    this.ref.on('child_changed', this.onChanged, this)
  	}

  	// dettach listeners from Firebase
  	detachFirebaseListeners () {
  	    this.ref.off('child_added', this.onAdded, this)
  	    this.ref.off('child_removed', this.onRemoved, this)
  	    this.ref.off('child_changed', this.onChanged, this)
  	}

	onAdded (snapshot) {
      // process data
      let stack = this.snapshotToStack(snapshot)
      // propagate event outwards with note
      this.emit('added', stack)
   }

   snapshotToStack (snapshot) {
       // we will need the key often, so we always want to have the key included in the note
       let key = snapshot.key
       let user = snapshot.val()
       user.key = key
       return user
     } 
}
export default new userFunctions()


// WEBPACK FOOTER //
// ./src/data/userFunctions.js